module.exports = __webpack_public_path__ + "img/20181216.518ccd08.png";